import { render, staticRenderFns } from "./render_file_file.vue?vue&type=template&id=286dd0c0&scoped=true&"
import script from "./render_file_file.vue?vue&type=script&lang=js&"
export * from "./render_file_file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286dd0c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286dd0c0')) {
      api.createRecord('286dd0c0', component.options)
    } else {
      api.reload('286dd0c0', component.options)
    }
    module.hot.accept("./render_file_file.vue?vue&type=template&id=286dd0c0&scoped=true&", function () {
      api.rerender('286dd0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/render_fields/render_file_file.vue"
export default component.exports